/**
 * Button Atom
 *
 * Botão reutilizável com variantes
 */
import React from 'react'
import { Loader2 } from 'lucide-react'

const variants = {
	primary: 'bg-primary hover:bg-primary-600 text-white',
	secondary: 'bg-secondary hover:bg-secondary-600 text-white',
	danger: 'bg-danger hover:bg-danger-light text-white',
	outline: 'border border-base-200 hover:bg-base-400 text-text',
	ghost: 'hover:bg-base-400 text-text-body',
}

const sizes = {
	sm: 'px-3 py-1.5 text-sm',
	md: 'px-4 py-2 text-sm',
	lg: 'px-6 py-3 text-base',
}

export default function Button({
	children,
	variant = 'primary',
	size = 'md',
	loading = false,
	disabled = false,
	icon: Icon,
	iconPosition = 'left',
	className = '',
	...props
}) {
	const baseClasses = 'inline-flex items-center justify-center font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed'

	return (
		<button
			className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
			disabled={disabled || loading}
			{...props}
		>
			{loading && (
				<Loader2 className="w-4 h-4 mr-2 animate-spin" />
			)}
			{!loading && Icon && iconPosition === 'left' && (
				<Icon className="w-4 h-4 mr-2" />
			)}
			{children}
			{!loading && Icon && iconPosition === 'right' && (
				<Icon className="w-4 h-4 ml-2" />
			)}
		</button>
	)
}
